<template>
  <v-text-field
    v-bind="$attrs"
    outlined
  />
</template>

<script>
  export default {
    name: 'TextField',
  }
</script>

<style scoped>

</style>
